'use strict';

module.exports = {
    getFreeGift: 'getFreeGift',
    getPoints: 'getPoints',
    redeemPoints: 'redeemPoints',
};
